import React from "react";
import { faClock } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ValueContainerProps, components } from "react-select";
import CreatableSelect from "react-select/creatable";
import { Label } from "react-aria-components";
import { Label as SemanticLabel } from "semantic-ui-react";
import { FilterOptionOption } from "react-select/dist/declarations/src/filters";

export interface InspectionTimeDropdownProps {
  value?: InspectionTimeDropdownOption | null;
  required?: boolean;
  label?: string;
  errorMessage?: string;
  onChange?: (value: InspectionTimeDropdownOption | null) => void;
  onCreate?: (newValue: string) => void;
  options?: InspectionTimeDropdownOption[];
}

export interface InspectionTimeDropdownOption {
  value: string | null;
  label: string;
}

export default function InspectionTimeDropdown({
  label,
  required,
  value,
  onChange,
  onCreate,
  options,
  errorMessage,
}: InspectionTimeDropdownProps) {
  const filterOption = (option: FilterOptionOption<InspectionTimeDropdownOption>, input: string): boolean => {
    return !input || option.label.toUpperCase().includes(input.toUpperCase());
  };

  return (
    <div className='tw-flex tw-flex-col'>
      {label && (
        <Label className='label-text tw-mb-1'>
          {label}
          {required && <span className='tw-ml-1 tw-text-red'>*</span>}
        </Label>
      )}
      <CreatableSelect
        styles={{
          control: (base, props) => {
            return {
              ...base,
              borderColor: props.menuIsOpen ? "#85b7d9" : "#22242626",
            };
          },
        }}
        isMulti={false}
        value={value}
        onChange={onChange}
        filterOption={filterOption}
        onCreateOption={onCreate}
        components={{
          ValueContainer: InspectionTimeDropdownSelectContainer,
        }}
        options={options ?? []}
      />
      {errorMessage && (
        <SemanticLabel basic prompt pointing='above'>
          {errorMessage}
        </SemanticLabel>
      )}
    </div>
  );
}
type InspectionTimeDropdownSelectContainerProps = ValueContainerProps<InspectionTimeDropdownOption, false>;
function InspectionTimeDropdownSelectContainer({ children, ...props }: InspectionTimeDropdownSelectContainerProps) {
  return (
    <div className='tw-flex tw-items-center'>
      <FontAwesomeIcon className='tw-ml-2 tw-text-xl tw-font-bold tw-text-grey' icon={faClock} />
      <components.ValueContainer {...props}>{children}</components.ValueContainer>
    </div>
  );
}
